import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWorkExperiences } from "../../Slices/employeeslice";
import Modal from "../../blueplanitUtils/Modal";
import { InputField, SelectInput } from "../../blueplanitUtils/InputField";
import { handleClose } from "./HandleClosePop/handleclose";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { TimePickerField } from "../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import { getOptionsByPath } from "../../utilsdata";
import { BASIC_INFO, EMPLOYMENT_TYPE, WORK_TYPE, SHIFT_TIMINGS, PROBATION_STATUS } from "../../Dropdownmanager";
export const BasicInfoModelPopUp = () => {
  const dispatch = useDispatch()
  const { handleSubmit } = useFormHandler()
  const Expirence = useSelector((state) => state.employee.workExperience);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  useEffect(() => {
    setWorkExperience({
      shiftInTime: Expirence?.shiftInTime || "",
      shiftOutTime: Expirence?.shiftOutTime || "",
      EmploymentType: Expirence?.EmploymentType || '',
      Experience: {
        years: Expirence?.Experience?.years || 0,
        months: Expirence?.Experience?.months || '',
      },
      WorkType: Expirence?.WorkType || '',
      ProbationStatus: Expirence?.ProbationStatus || '',
      probationPeriod: Expirence?.probationPeriod || '',
    });
  }, [Expirence])
  const [workExperience, setWorkExperience] = useState()
  const [basicinfo, setBasicInfo] = useState({});
  const [basicValid, setBasicValid] = useState(false);

  const handleBasicChange = (e) => {
    const { name, value } = e.target;
    if (name === "years" || name === "months") {
      setWorkExperience((prev) => ({
        ...prev,
        Experience: { ...prev.Experience, [name]: value },
      }));
    } else {
      setWorkExperience((prev) => ({ ...prev, [name]: value }));
    }

    let newErrors = { ...basicinfo };

    switch (name) {
      case "EmploymentType":
        if (!value.trim()) {
          newErrors.EmploymentType = "Employment Type is required.";
        } else {
          delete newErrors.EmploymentType; // Remove error if the field is valid
        }
        break;
      case "WorkType":
        if (!value.trim()) {
          newErrors.WorkType = "Work Type is required.";
        } else {
          delete newErrors.WorkType;
        }
        break;
      case "shiftInTime":
        if (!value) newErrors.shiftInTime = "shiftin time is required.";
        else delete newErrors.shiftInTime;
        break;

      case "shiftOutTime":
        if (!value) newErrors.shiftOutTime = "shiftout time is required.";
        else delete newErrors.shiftOutTime;
        break;

      case "years":
        if (!value.trim()) {
          newErrors.years = "Years of experience is required.";
        } else if (isNaN(value) || value < 0 || value > 60) {
          newErrors.years = "Years of experience must be between 0 and 60.";
        } else {
          delete newErrors.years;
        }

        break;
      case "months":
        if (!value.trim()) {
          newErrors.months = "Months of experience is required.";
        } else if (isNaN(value) || value < 0 || value > 11) {
          newErrors.months =
            "Months of experience must be a non-negative number and less than or equal to 11.";
        } else {
          delete newErrors.months;
        }
        break;
      case "ProbationStatus":
        if (!/^[A-Za-z\s-]+$/.test(value)) {
          newErrors.ProbationStatus = "Probation Status is required, only letters and spaces allowed.";
        } else {
          delete newErrors.ProbationStatus;
        }
        break;
      case "probationPeriod":
        if (!value.trim()) {
          newErrors.probationPeriod = "Probation Period is required.";
        } else if (isNaN(value) || value < 0) {
          newErrors.probationPeriod = "Probation Period must be a non-negative number.";
        } else if (value < 30 || value > 180) {
          newErrors.probationPeriod =
            "Probation Period must be greater than 30 days and less than 180 days.";
        } else {
          delete newErrors.probationPeriod;
        }
        break;
      default:
        break;
    }
    setBasicInfo(newErrors);
    const requiredFields = [
      "EmploymentType",
      "WorkType",
      "shiftInTime",
      "shiftOutTime",
      "months",
      "ProbationStatus",
      "probationPeriod",
    ];
    setWorkExperience((prev) => {
      const allFieldsValid = requiredFields?.every((field) => {
        const fieldValue =
          field === "months"
            ? prev.Experience[field]
            : prev[field];
        const fieldError = newErrors[field];
        return fieldValue && !fieldError;
      });
      setBasicValid(allFieldsValid);
      return prev;
    });
  };
  const handleBasicSave = async (e) => {
    e.preventDefault();
    let newErrors = { ...basicinfo };
    if (!workExperience.EmploymentType) newErrors.EmploymentType = "Employment Type is required";
    if (!workExperience.WorkType) newErrors.WorkType = "Work Type is required";
    if (!workExperience.shiftInTime) newErrors.shiftInTime = "shiftin time is required";
    if (!workExperience.shiftOutTime) newErrors.shiftOutTime = "shiftout time is required";
    if (
      workExperience.Experience?.years === undefined ||
      workExperience.Experience?.years === null ||
      workExperience.Experience?.years < 0 ||
      workExperience.Experience?.years > 60
    ) {
      newErrors.years = "Years of experience must be between 0 and 60";
    }

    if (!workExperience.Experience?.months) newErrors.months = "Months of experience is required";
    if (!workExperience.ProbationStatus?.trim()) {
      newErrors.ProbationStatus = "Probation Status is required";
    }
    if (!workExperience.probationPeriod?.trim()) {
      newErrors.probationPeriod = "Probation Period is required";
    }

    setBasicInfo(newErrors);

    const noErrors = Object.keys(newErrors).length === 0;
    const input = {
      shiftInTime: workExperience.shiftInTime,
      shiftOutTime: workExperience.shiftOutTime,
      EmploymentType: workExperience.EmploymentType,
      Experience: {
        years: parseInt(workExperience.Experience?.years),
        months: parseInt(workExperience.Experience?.months),
      },
      WorkType: workExperience.WorkType,
      ProbationStatus: workExperience.ProbationStatus,
      probationPeriod: workExperience.probationPeriod,
    }
    try {
      const val = await handleSubmit({
        noErrors,
        formValid: basicValid,
        dataObj: input,
        action: "Basicinfo",
        ModalName: "BasicinfoModalpopup",
        submitAction: "handleBasicinfoSubmit",
      });
      if (val) {
        dispatch(setWorkExperiences({
          shiftInTime: workExperience.shiftInTime,
          shiftOutTime: workExperience.shiftOutTime,
          EmploymentType: workExperience.EmploymentType,
          Experience: {
            years: parseInt(workExperience.Experience?.years),
            months: parseInt(workExperience.Experience?.months),
          },
          WorkType: workExperience.WorkType,
          ProbationStatus: workExperience.ProbationStatus,
          probationPeriod: workExperience.probationPeriod,
        }));

        setBasicValid(false);
      }
    }

    catch (error) {
    } finally {
      if (noErrors && basicValid) {
        setBasicInfo(false);
      }
    }
  };
  return (
    <Modal
      id="basic_info_model"
      title="Work Experience"
      handleModalClose={() =>
        handleClose(Expirence, setWorkExperience, setBasicInfo)
      }
      handleSubmit={handleBasicSave}
      isUserDataValid={false}
    >
      <div className="row">

        {/* Row 1 */}
        <div className="col-md-3">
          <SelectInput
            formControl={true}
            required={true}
            label="Employment Type"
            name="EmploymentType"
            value={workExperience?.EmploymentType || ""}
            onChange={(e) =>
              handleBasicChange({
                target: { name: "EmploymentType", value: e },
              })
            }
            error={basicinfo?.EmploymentType}
            options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, EMPLOYMENT_TYPE])}
          />
        </div>

        <div className="col-md-3">
          <SelectInput
            formControl={true}
            required={true}
            label="Work Type"
            name="WorkType"
            value={workExperience?.WorkType || ""}
            onChange={(e) =>
              handleBasicChange({
                target: { name: "WorkType", value: e },
              })
            }
            error={basicinfo?.WorkType}
            options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, WORK_TYPE])}
          />
        </div>

        <div className="col-md-3">
          <TimePickerField
            format="HH:mm"
            label="Shift In Time"
            name="shiftInTime"
            value={
              workExperience?.shiftInTime
                ? dayjs(workExperience.shiftInTime, "HH:mm")
                : null
            }
            onChange={(time, timeString) =>
              handleBasicChange({
                target: { name: "shiftInTime", value: timeString },
              })
            }
            style={{ width: "100%" }}
          />


          {basicinfo?.shiftInTime && (
            <p className="text-danger">{basicinfo.shiftInTime}</p>
          )}
        </div>

        <div className="col-md-3">
          <TimePickerField
            format="HH:mm"
            label="Shift Out Time"
            name="shiftOutTime"
            value={
              workExperience?.shiftOutTime
                ? dayjs(workExperience.shiftOutTime, "HH:mm")
                : null
            }
            onChange={(time, timeString) =>
              handleBasicChange({
                target: { name: "shiftOutTime", value: timeString },
              })
            }
            style={{ width: "100%" }}
          />


          {basicinfo?.shiftOutTime && (
            <p className="text-danger">{basicinfo.shiftOutTime}</p>
          )}
        </div>

        {/* Row 2 */}
        <div className="col-md-3">
          <InputField
            formcontrol="form-control"
            required={true}
            label="Experience (Years)"
            type="number"
            name="years"
            value={workExperience?.Experience?.years}
            onChange={handleBasicChange}
            max="60"
            min="0"
            error={basicinfo?.years}
          />
        </div>

        <div className="col-md-3">
          <InputField
            formcontrol="form-control"
            required={true}
            label="Experience (Months)"
            type="number"
            name="months"
            value={workExperience?.Experience?.months}
            onChange={handleBasicChange}
            max="11"
            min="0"
            error={basicinfo?.months}
          />
        </div>

        <div className="col-md-3">
          <SelectInput
            formControl={true}
            required={true}
            label="Probation Status"
            name="ProbationStatus"
            value={workExperience?.ProbationStatus || ""}
            onChange={(e) =>
              handleBasicChange({
                target: { name: "ProbationStatus", value: e },
              })
            }
            error={basicinfo?.ProbationStatus}
            options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, PROBATION_STATUS])}
          />
        </div>

        <div className="col-md-3">
          <InputField
            formcontrol="form-control"
            required={true}
            label="Probation Period (Days)"
            name="probationPeriod"
            value={workExperience?.probationPeriod}
            onChange={handleBasicChange}
            error={basicinfo?.probationPeriod}
          />
        </div>

      </div>
    </Modal>


  )
}